module.exports = __webpack_public_path__ + "img/logo-school-4.b34ed791.png";